import { VERSION_PARAM } from 'src/app/shared/constants/queryParams';
import { isServerRendering } from 'src/app/utils/environment';
import { setQueryParam } from 'src/app/utils/queryParams';

import { getUivQueryParam } from '../getUivQueryParam';
import { getUivInStorage, setUivInStorage } from '../sessionStorage';

// Used within src/app/client.tsx which is skipped by pruning
// ts-prune-ignore-next
export const persistUivParams = () => {
  if (isServerRendering()) {
    return;
  }

  const queryVersion = getUivQueryParam();
  if (queryVersion) {
    setUivInStorage(queryVersion);
  }

  const sessionVersion = getUivInStorage();
  if (queryVersion || sessionVersion) {
    setQueryParam(VERSION_PARAM, queryVersion ?? sessionVersion);
  }
};
